export default {
  watermark: {
    title: "Customise watermark",
    button: {
      cancel: "Cancel",
      save: "Save changes",
    },
    detail: {
      title: "Select what you would like to include in your watermark:",
      tips: "*If there are multiple branches within your organisation we will choose one for the preview.",
      checkbox: {
        agency: "Agency name",
        branch: "Branch name",
        agent: "Agent name",
      },
    },
    note: {
      prefix: "<strong>Note: </strong>You will only see the watermark on ",
      website: "iproperty.com.my",
      suffix: " once it’s published online.",
    },
    message: {
      success: "Your watermark has been updated successfully!",
    },
  },
};
